import { LIST_PROVINCES } from "../actions";

export function province(state = [], action) {
  switch (action.type) {
    case LIST_PROVINCES:
      return action.payload.data.map((item) => ({ value: item.id, label: item.name }));
    default:
      return state;
  }
}
